import React, { useEffect, useState } from "react";
import { Outlet, useSearchParams, useNavigate } from "react-router-dom";
import {
  validateAccess,
  fetchTokenByCode,
  HttpError,
  refreshToken,
} from "../../features/request";

const PrivateRoute: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const code = searchParams.get("code");
  const redirect_uri =
    searchParams.get("redirect_uri") || window.location.origin;

  const [loading, setLoading] = useState(true);
  const [authorized, setAuthorized] = useState(false);
  const [noAccess, setNoAccess] = useState(false);

  async function handleLocalTokens() {
    const access = localStorage.getItem("access");
    const csrf = localStorage.getItem("csrf_token");

    if (!access || !csrf) {
      navigate("/login")
      return;
    }

    try {
      const ok = await validateAccess(access, "entry", csrf);
      if (ok) {
        setAuthorized(true);
        return; 
      }
    } catch (err) {
      if (err instanceof HttpError && err.status === 403) {
        setNoAccess(true); 
        return;
      }
    }

    const refreshed = await refreshToken();
    if (typeof refreshed !== "string") {
      navigate("/login")
      return;
    }

    try {
      const ok2 = await validateAccess(refreshed, "entry", csrf);
      if (ok2) {
        setAuthorized(true);
        return;
      }
      setNoAccess(true);
    } catch (err) {
      if (err instanceof HttpError && err.status === 403) {
        setNoAccess(true);
      } else {
        navigate("/login")
      }
    }
  }

  useEffect(() => {
    let cancelled = false;

    async function checkAuthFlow() {
      try {
        if (code) {
          await fetchTokenByCode(code, redirect_uri);
          if (cancelled) return;

          const sp = new URLSearchParams(searchParams);
          sp.delete("code");
          sp.delete("redirect_uri");
          navigate(
            { pathname: window.location.pathname, search: sp.toString() },
            { replace: true }
          );
        }

        await handleLocalTokens();
      } catch (err) {
        if (err instanceof HttpError && err.status === 403) {
          setNoAccess(true);
        } else {
          navigate('/login')
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    checkAuthFlow();
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) {
    return <div>Загрузка...</div>;
  }
  if (noAccess) {
    return (
      <div style={{ color: "red", textAlign: "center" }}>
        У вас нет прав доступа на просмотр этой страницы.
      </div>
    );
  }
  if (authorized) {
    return <Outlet />;
  }
  return null;
};

export default PrivateRoute;
